export default "__VITE_ASSET__ye5S7nO___"